import { useState } from "react";
import { toast } from "sonner";
import { FileText, Eye } from "lucide-react";
import { api, BACKEND, errMsg } from "@/lib/api";
import { download } from "@/admin/hr/common";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Loading, Table, Title, fmtDT, useData } from "@/ops/ui";
import { FilterBar } from "@/ops/filters";

function Detail({ item, onClose }) {
  const [v, setV] = useState({ status: item.status, result: item.result || "" });
  const save = async () => {
    try {
      await api.put(`/ops/admin/incidents/${item.id}`, v);
      toast.success("Olay kaydı güncellendi");
      onClose(true);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose(false)}>
      <DialogContent className="max-h-[92vh] max-w-2xl overflow-y-auto" data-testid="incident-dialog">
        <DialogHeader><DialogTitle>{item.no} · {item.category}</DialogTitle></DialogHeader>
        <p className="text-sm text-zinc-600">{item.project_name} · {item.place} · {fmtDT(item.occurred_at)} · Bildiren: {item.employee_name}</p>
        <p className="whitespace-pre-wrap rounded bg-zinc-50 p-3 text-sm">{item.description}</p>
        <div className="flex flex-wrap gap-2">{item.files.map((f) => <a key={f.id} href={`${BACKEND}/api/ops/admin/incidents/${item.id}/files/${f.id}`} target="_blank" rel="noreferrer" className="btn-outline !px-3 !py-1.5 text-xs"><Eye className="h-3 w-3" /> {f.filename}</a>)}</div>
        <ul className="text-xs text-zinc-500">{item.history.map((x) => <li key={x.at}>{fmtDT(x.at)} – {x.by}: {x.action}</li>)}</ul>
        <select value={v.status} onChange={(e) => setV({ ...v, status: e.target.value })} className="field-input" data-testid="incident-status">{["Açık", "İnceleniyor", "Kapatıldı"].map((s) => <option key={s}>{s}</option>)}</select>
        <textarea value={v.result} onChange={(e) => setV({ ...v, result: e.target.value })} placeholder="İnceleme sonucu / yapılan işlem" rows={3} className="field-input" data-testid="incident-result" />
        <div className="flex justify-between gap-2">
          <button onClick={() => download(`/ops/admin/incidents/${item.id}/pdf`, `tutanak-${item.no}.pdf`)} className="btn-outline !py-2" data-testid="incident-pdf"><FileText className="h-4 w-4" /> PDF Tutanak</button>
          <button onClick={save} className="btn-red !py-2" data-testid="incident-save">Kaydet</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default function Incidents() {
  const [f, setF] = useState({ date_from: "", date_to: "", project_id: "", employee_id: "" });
  const [rows, reload] = useData("/ops/admin/incidents", f);
  const [sel, setSel] = useState(null);
  return (
    <div>
      <Title title="Olay Bildirimleri ve Tutanaklar" desc="Personelin telefondan bildirdiği olaylar. Varsayılan olarak son 30 gün gösterilir." />
      <FilterBar f={f} setF={setF} />
      {!rows ? <Loading /> : (
        <Table head={["No", "Tarih", "Proje / Yer", "Kategori", "Bildiren", "Ek", "Durum"]} testid="incidents-table">
          {rows.map((r) => (
            <tr key={r.id} onClick={() => setSel(r)} className="cursor-pointer hover:bg-zinc-50" data-testid={`incident-row-${r.id}`}><td className="px-3 py-2 font-semibold text-[color:var(--red)]">{r.no}</td><td className="whitespace-nowrap px-3 py-2 text-xs">{fmtDT(r.occurred_at)}</td><td className="px-3 py-2">{r.project_name}<p className="text-xs text-zinc-500">{r.place}</p></td><td className="px-3 py-2">{r.category}</td><td className="px-3 py-2">{r.employee_name}</td><td className="px-3 py-2">{r.files.length}</td><td className="px-3 py-2 text-xs font-semibold">{r.status}</td></tr>
          ))}
          {!rows.length && <tr><td colSpan={7} className="p-6 text-center text-zinc-500">Olay bildirimi yok.</td></tr>}
        </Table>
      )}
      {sel && <Detail item={sel} onClose={(ok) => { setSel(null); if (ok) reload(); }} />}
    </div>
  );
}
